import { boolean, object } from "yup"
const validationSchema = object().shape({
    agreedToProgramGuidelines: boolean(),
    agreedToMedicalTermsAndConditions: boolean(),
    agreedToTermsAndConditions: boolean(),
})

export default validationSchema